import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./eventsStyle.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Cookies from "js-cookie";

export default function Events() {
    const navigate = useNavigate();

    const [nextEvents, setNextEvents] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    const fadeTimeoutRef = useRef(null);
    const FADE_DURATION = 180;

    useEffect(() => {
        document.title = "DJ - EMAN"

        getNextEvents();

        AOS.init({
            duration: 1000,
            once: false
        });

        return () => {
            if (fadeTimeoutRef.current) clearTimeout(fadeTimeoutRef.current);
        }
    }, []);

    useEffect(() => {
        if (modalOpen) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }

        return () => document.body.classList.remove('modal-open');
    }, [modalOpen]);

    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape') closeModal();
        };

        if (modalOpen) document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [modalOpen]);

    function openModal(event) {
        setSelectedEvent(event);
        setModalVisible(true);
        fadeTimeoutRef.current = setTimeout(() => {
            setModalOpen(true);
        }, 10);
    }

    function closeModal() {
        setModalOpen(false);
        if (fadeTimeoutRef.current) clearTimeout(fadeTimeoutRef.current);
        fadeTimeoutRef.current = setTimeout(() => {
            setModalVisible(false);
            setSelectedEvent(null);
        }, FADE_DURATION + 10);
    }

    const getNextEvents = async (e) => {
        try {
            const response = await fetch("https://djeman.de:8443/api/v1/nextevents", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (response.status == 200) {
                setNextEvents(await response.json());
            }
        } catch (error) {
            console.error("Fehler beim API Request: ", error);
        }
    }

    function dateFormatter(date) {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');

        return `${day}.${month}.${year} ${hours}:${minutes} Uhr`;
    }

    return (
        <div className="eventsContainer">
            <h1>Events</h1>
            <h2>Sehe dir die nächsten Events mit DJ-EMAN an</h2>
            <div className="nextEventsContainer">
                {nextEvents.map((event, idx) => (
                    <div
                        key={event.id ?? `${event.title}-${idx}`}
                        data-aos="fade-up"
                        data-aos-anchor-placement="top-bottom"
                        className="nextEventContainer"
                        onClick={() => openModal(event)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') openModal(event); }}
                    >
                        <h2>{event.title}</h2>
                        <div className="descriptionWrapper">
                            <h6>{event.description}</h6>
                        </div>
                        <div className="dateAndLocationContainer">
                            <hr />
                            <div>
                                <h3>Datum</h3>
                                <h4>{dateFormatter(event.date)}</h4>
                            </div>
                            <hr />
                            <div>
                                <h3>Ort</h3>
                                <h4>{event.location}</h4>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {modalVisible && selectedEvent && (
                <div className={`modal-overlay ${modalOpen ? 'open' : ''}`} onClick={closeModal}>
                    <div
                        className={`modal ${modalOpen ? 'open' : ''}`}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="modal-close-btn" onClick={closeModal} aria-label="Schließen">
                            ×
                        </button>
                        <div className="modal-content">
                            <h2 id="modal-title">{selectedEvent.title}</h2>
                            <div className="modal-meta">
                                <span>{dateFormatter(selectedEvent.date)}</span>
                                <span> • </span>
                                <span>{selectedEvent.location}</span>
                            </div>
                            <div className="modal-body">
                                <p>{selectedEvent.description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
